<template>
<!-- HISTORY: no-version
   V260527.1: Made the Query menu accessible to Kushal as well.
   V260320.1: Added Settings menu.
   V260227.1: Made the Query menu accessible only to the Power Admin.
   V251027.1: Added Dashboards menu.
   V250902.1: Added AI Assistant menu and made it available to Admin Power only.
   V250625.1: Added Query menu + Changed File Structure to Folder Structure (and files to folders).
   V250617.1: Added File Structure (files) menu.
   V250616.1: 1st release.
-->
   <nav>
      <v-navigation-drawer permanent
         class="lighten-2 full-height px-0"
         style="background-color: #f6f6f6; height: 91vh; position:sticky; top:50px; z-index:2"
         mini-variant-width="60"
         width="220"
         :mini-variant="miniVariant"
      >
         <v-list class="py-0">
            <v-divider color="white"></v-divider>
            <v-list-item :dense="true">
               <v-list-item-icon>
                  <v-icon class="grey--text">cloud_sync</v-icon><!-- mdi-database -->
               </v-list-item-icon>
               <v-list-item-content>
                  <v-list-item-title class="body-2 grey--text font-italic">Lake Services</v-list-item-title>
               </v-list-item-content>
            </v-list-item>
         </v-list>

         <v-divider class="my-2" dark></v-divider>

         <v-list class="py-0" flat>
            <v-list-item v-for="item in permittedItems"
               link
               :key="item.title"
               :to="getLink(item.route)"
            >
               <v-list-item-icon>
                  <v-icon>{{ item.icon }}</v-icon>
               </v-list-item-icon>
               <v-list-item-content>
                  <v-list-item-title class="caption font-weight-bold" >{{ item.title }}</v-list-item-title>
               </v-list-item-content>
            </v-list-item>
            <v-divider color="white"></v-divider>
            <v-list-item @click="toggleMenu()">
               <v-list-item-icon>
                  <v-icon>more_horiz</v-icon>
               </v-list-item-icon>
            </v-list-item>
         </v-list>
      </v-navigation-drawer>
   </nav>
</template>

<script>
function _compareItems (item1, item2) {
   return item1.seq > item2.seq ? 1 : -1;
}

export default {
   props: {
      baseRoute: {
         type: String,
         required: true
      },
      debug: {
         type: Boolean,
         default: false
      },
      miniVariant: {
         type: Boolean,
         default: false
      }
   },

   data() {
      return {
         items: [
            { seq: 0, icon: 'dashboard', title: 'Dashboards', route: 'dashboards', policy: '' },
            { seq: 1, icon: 'cloud_upload', title: 'ETLs', route: 'exports', policy: '' },
            { seq: 2, icon: 'folder_open', title: 'Folder Structure', route: 'folders', policy: '' },
            //v260527: Added allowedEmails prop
            //v260227: Added isPowerAdmin to policy
            { seq: 3, icon: 'query_stats', title: 'Query', route: 'query', policy: 'isPowerAdmin', allowedEmails: ['kdutta@mindfireinc.com'] },
            { seq: 4, icon: 'auto_fix_high', title: 'AI Assistant', route: 'ai-assistant', policy: 'isPowerAdmin' },
            { seq: 5, icon: 'settings', title: 'Settings', route: 'settings', policy: '' }
         ],
         permittedItems: [],
         myStyle: 'background-color: #f6f6f6; height: 91vh; overflow-y:unset; position:sticky; top:0',
         // jwt: {}
      }
   },

   computed: {
      token() {
         return this.$store.getters.token;
      },

      userPolicies() {
         return this.$store.getters.user.policies;
      },

      isPowerAdmin() {
         return this.$store.getters.user.isPowerAdmin;
      }
   },

   watch: { 
      token: {
         handler (val) {
            // this.jwt = JSON.parse(Buffer.from(val.split('.')[1], 'base64'));
            this.getPermittedItems();
         }
      },

      userPolicies: {
         immediate: true,
         deep: true,
         handler () {
            this.getPermittedItems();
         }
      },

   },

   methods: {
      getLink(route) {
         return "/" + this.baseRoute + "/" + route;
      },

      toggleMenu() {
         this.$emit('more-click');
      },

      getPermittedItems() {
         // if (this.token && this.userPolicies) {
         //    const permittedItems = this.items.filter(item => this.userPolicies.includes(item.policy));
         //    this.permittedItems = permittedItems.sort(_compareItems);
         // }
         if (this.token) {
            const email = this.$store.getters.user.email;
            // const permittedItems = this.items;
            //V260527: const permittedItems = this.items.filter(item => !item.policy || (this.isPowerAdmin && item.policy === 'isPowerAdmin'));
            const permittedItems = this.items.filter(item =>
               !item.policy ||
               (this.isPowerAdmin && item.policy === 'isPowerAdmin') ||
               item.allowedEmails?.includes(email)
            );
            this.permittedItems = permittedItems.sort(_compareItems);
         }
      }
   },
   
   created() { }
}
</script>

<style scope>
   .v-list .v-list-item--active {
      color:#ff6633;
      background: #f6f6f6;
  }
</style>